import type { ChatLocale } from '@citiguide/shared';

/**
 * UI language key (the language store / i18n resource key) -> ISO locale the chat API understands.
 * Spanish is `es` in the language store and `sp` in the locale file name; Swedish is `se` in the UI
 * and `sv` in ISO. Anything unknown falls back to `es`, the canonical content language.
 */
export const toChatLocale = (uiLanguage: string | undefined | null): ChatLocale => {
  switch ((uiLanguage ?? '').toLowerCase()) {
    case 'en':
      return 'en';
    case 'fi':
      return 'fi';
    case 'se':
    case 'sv':
      return 'sv';
    default:
      return 'es';
  }
};
